const config = {
    // URL:'http://localhost/training/health/BE/public/'
    // URL:'http://localhost:8000/' // laragon 
    // URL:'http://localhost:99/' // docker 
    URL:'https://vanmanh.azurewebsites.net/'
    
}

export default config